import { loaderGrid } from "../../../../middleware/route-provider.js";

const OPERATOR_HUB_APIS = {
  checkNew: "SLN/SolarentOperator/CheckNewRequest",
  inProcess: "SLN/SolarentOperator/InProcessRequest",
  all: "SLN/SolarentOperator/AllRequests",
};

const MANAGEMENT_HUB_APIS = {
  checkNew: "SLN/Management/CheckNewRequest",
  inProcess: "SLN/Management/InProcessRequest",
  all: "SLN/Management/AllRequest",
};

export const loaderProjectWorkspaceHub =
  (configKey = "solarentOperator") =>
  async ({ request }) => {
    const url = new URL(request.url);
    const view = url.searchParams.get("view") || "inProcess";
    // «همه درخواست‌ها» صفحه‌بندی سمت سرور دارد؛ prefetch کل لیست را حذف می‌کنیم.
    if (view === "all") {
      return [];
    }
    const apiMap =
      configKey === "management" ? MANAGEMENT_HUB_APIS : OPERATOR_HUB_APIS;
    return loaderGrid({ url: apiMap[view] || apiMap.inProcess });
  };
